import { render } from "./Pyramide.vue?vue&type=template&id=66923743"
import script from "./Pyramide.vue?vue&type=script&lang=js"
export * from "./Pyramide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__